import { useMemo } from 'react';
import { getCurrentUser, hasAllPermissions, type UserBundle } from './auth';

export function useAuth() {
  return useMemo(
    () => ({
      user: getCurrentUser() as UserBundle | null,
      hasPermission: (perm: string) => {
        const u = getCurrentUser();
        if (!u) return false;
        if (u.rol === 'ADMIN') return true;
        return u.permisos?.includes(perm) ?? false;
      },
      hasAllPermissions,
    }),
    [],
  );
}

export function useHasPermission(...required: string[]) {
  const { user } = useAuth();
  if (!user) return false;
  if (user.rol === 'ADMIN') return true;
  return required.every((p) => user.permisos?.includes(p));
}
